import React from 'react';
import styles from './styles.module.scss';

const TopWrapper = ({
    background,
    children,
}) => (
    <div className={styles.TopWrapper} data-has-background={Boolean(background)}>
        {background && (
            <div
                className={styles.TopWrapperPicture}
                style={{ backgroundImage: `url(${background})` }}
            />
        )}

        { children }
    </div>
);

export default TopWrapper;
